import React, { useContext, useState } from 'react'
import { TabPanel } from '../Tabs/TabPanel'
import { TeamRoster } from '../rosters/teamRoster'
import { MatchupContext } from '../../../../Context'
import { TabHeaderStyle } from '../../../../Components/Tab/styles'
import { Tab } from '../../../../Components/LazyComponents'

type RosterProps = {
  awayTeam: string
  homeTeam: string
}

export const RosterTabs: React.FC<React.PropsWithChildren<RosterProps>> = ({
  awayTeam,
  homeTeam,
}) => {
  const { awayPlayers, homePlayers } = useContext(MatchupContext)!
  const [value, setValue] = useState(0)

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  return (
    <>
      {awayTeam && homeTeam && (
        <>
          <TabHeaderStyle
            tabColor="dark"
            topRadius={8}
            value={value}
            onChange={handleChange}
            aria-label="roster tabs"
            centered
          >
            <Tab label={awayTeam} />
            <Tab label={homeTeam} />
          </TabHeaderStyle>
          <TabPanel value={value} index={0}>
            <TeamRoster players={awayPlayers} theme="dark" />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TeamRoster players={homePlayers} theme="dark" />
          </TabPanel>
        </>
      )}
    </>
  )
}
